import { render, staticRenderFns } from "./user_left.vue?vue&type=template&id=1ed60330&scoped=true"
import script from "./user_left.vue?vue&type=script&lang=js"
export * from "./user_left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed60330",
  null
  
)

export default component.exports